import { ImageExtension } from "store/types/imageExtension";

export const getImageExtension = (file: File): ImageExtension =>
    (file.name ?? "").split(".")[(file.name ?? "").split(".").length - 1].split("?")[0].toLowerCase() as ImageExtension;

export const getImageExtensionFromTitle = (title: string) =>
    (title ?? "").split(".")[(title ?? "").split(".").length - 1].split("?")[0].toLowerCase() as ImageExtension;
